import useAppSelector from 'app/hooks/useAppSelector'
import { LicenseType } from 'features/licenses/types'
import { selectDealerByLicenseDomainId } from 'features/rootDomains/selectors'

interface LicenseDomainNameProps {
  license: LicenseType
  rootDomainId: string | null
  youAreDistributor: boolean | null
}

function LicenseDomainName({
  license,
  rootDomainId,
  youAreDistributor,
}: LicenseDomainNameProps) {
  const dealer = useAppSelector(selectDealerByLicenseDomainId(license.domainId))
  const transferredLicense =
    license.domainId &&
    license.domainId !== rootDomainId &&
    license.purchaserDomainId === rootDomainId
  const canRenderDomainName = transferredLicense && youAreDistributor
  const domainName = canRenderDomainName && dealer?.name

  return <>{domainName}</>
}

export default LicenseDomainName
